<template>
  <v-card class="secondary">
    <iframe
      v-if="news.video && platform(news.video) == 'youtube'"
      width="95%"
      :height="$vuetify.breakpoint.mdAndDown ? '225' : '315'"
      class="mt-5"
      :src="'https://www.youtube.com/embed/' + videoToken(news.video)"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    >
    </iframe>
    <iframe
      v-if="news.video && platform(news.video) == 'vimeo'"
      :src="'https://player.vimeo.com/video/' + videoToken(news.video)"
      width="640"
      height="360"
      frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture"
      allowfullscreen
    ></iframe>
    <v-img
      v-if="news.photo"
      :src="news.photo"
      height="200px"
      class="mt-5"
    ></v-img>

    <v-card-title>
      <div v-html="news.title" class="break-word text-left"></div>
    </v-card-title>

    <v-card-text>
      <div v-html="news.description" class="break-word text-justify"></div>
    </v-card-text>

    <v-card-text>
      <Preview
        v-if="news.link_details"
        :details="news.link_details"
        cardWidth="100%"
      />
    </v-card-text>
    <v-card-text v-if="edit">
      <AdminNewsForm
        :title="news.title"
        :description="news.description"
        :video="news.video"
        :link="news.link"
        :photo="news.photo"
        :news_id="news.id"
        @publishNews="edit = false"
      />
    </v-card-text>

    <v-card-actions>
      <v-row justify="space-between">
        <v-col class="pt-0 text-left">
          <v-btn text @click="showExpansion = !showExpansion">
            <v-icon class="mr-2 ml-n2">{{
              showExpansion ? "mdi-chevron-up" : "mdi-chevron-down"
            }}</v-icon>
            {{ commentsLength > 0 ? commentsLength : "" }} comments
          </v-btn>
        </v-col>
        <v-col class="pt-0 mr-2 mt-2 text-right">
          <span class="caption"
            >{{ news.date | parseDate }}
            <div v-if="author">by {{ author }}</div></span
          >
        </v-col>
        <v-col
          class="pt-0 mr-2 mt-2 text-right"
          v-if="user && user.email && user.is_admin"
        >
          <v-btn text @click="editNews" class="primary mr-2">
            <v-icon class="mr-2 ml-n2">mdi-pen</v-icon>
            Edit
          </v-btn>
          <v-btn text @click="deleteNews" class="primary">
            <v-icon class="mr-2 ml-n2">mdi-delete</v-icon>
            Delete
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
    <v-expand-transition>
      <div v-show="showExpansion">
        <v-divider></v-divider>

        <v-card-text>
          <ListComments @commentPosted="commentPosted" :news_id="news.id" />
        </v-card-text>
      </div>
    </v-expand-transition>
  </v-card>
</template>
<script>
import axios from "axios";

export default {
  name: "ItemNews",

  data() {
    return {
      commentsLength: 0,
      showExpansion: false,
      edit: false
    };
  },

  components: {
    AdminNewsForm: () => import("./forms/AdminNewsForm.vue"),
    ListComments: () => import("./ListComments.vue"),
    Preview: () => import("./cards/Preview.vue")
  },

  props: {
    news: {
      type: Object,
      required: true
    }
  },

  methods: {
    editNews() {
      this.edit = true;
    },
    deleteNews() {
      const _vm = this;

      axios
        .post(
          `${this.$BASE_URL}/publish_news`,
          {
            id: this.$props.news.id,
            title: this.$props.news.title,
            description: this.$props.news.description,
            photo: this.$props.news.photo,
            video: this.$props.news.video,
            link: this.$props.news.link,
            display_in_news_list: false
          },
          {
            headers: {
              Authorization: `Bearer ${this.user.token}`
            }
          }
        )
        .then(() => {
          _vm.refreshNewsList();
        });
    },
    refreshNewsList() {
      this.$store.dispatch("getData", {
        endpoint:
          '/get/news?limit=15&order_by=id&relations=author,comments&filter_by={"display_in_news_list":true}',
        store_as: "news"
      });
    },
    commentPosted() {
      this.commentsLength += 1;
    },
    platform(videoUrl) {
      if (videoUrl.includes("youtu")) return "youtube";
      if (videoUrl.includes("vimeo")) return "vimeo";
    },
    videoToken(videoUrl) {
      if (videoUrl.includes("watch"))
        return this._.split(videoUrl, "watch?v=")[1];
      if (videoUrl.includes("embed"))
        return this._.split(videoUrl, "embed/")[1];
      if (videoUrl.includes("youtube.com/v/"))
        return this._.split(videoUrl, "youtube.com/v/")[1];
      if (videoUrl.includes("youtu.be/"))
        return this._.split(videoUrl, "youtu.be/")[1];
      if (videoUrl.includes("vimeo.com/")) {
        let sub = this._.split(videoUrl, "vimeo.com/")[1];
        if (sub.includes("/")) return sub.replace("/", "?h=");
        else return sub;
      }
    }
  },

  watch: {
    comments(value) {
      if (value == null) this.commentsLength = 0;
      this.commentsLength = value.length;
    }
  },

  computed: {
    comments() {
      if (!this.$props.news || !this.$props.news.comments) return null;
      return this.$props.news.comments;
    },
    author() {
      if (!this.$props.news.author || !this.$props.news.author.name)
        return null;
      return this.$props.news.author.name;
    },
    user() {
      return this.$store.getters["loginUser"];
    }
  },

  mounted() {
    if (this.comments == null) this.commentsLength = 0;
    else this.commentsLength = this.comments.length;
  }
};
</script>
